/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

export const InputRangeSliderStyled = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 68px;

    .slider__draggable {
        position: relative;
        display: flex;
        width: 100%;
        height: 100%;
    }

    .slider-thumb {
        position: absolute;
        width: 44px;
        padding-top: 20px;
        padding-bottom: 20px;
        height: 28px;
        cursor: pointer;
    }
`

export const InputRangeSliderSlotStyled = styled.div.attrs(({ isBefore }: { isBefore: boolean}) => ({
    className: `slot ${isBefore ? 'slot_before' : 'slot_after'}`,
}))<{ isBefore: boolean}>`
    display: flex;
    height: 100%;
    padding: 8px 0;
    box-sizing: border-box;
    cursor: pointer;

    &.slot_before {
        background: #D9FFE8;
        .slider__scale-mark {
            border-color: #C5EED5;
        }
    }

    &.slot_after {
        background: #FFEDFF;
        .slider__scale-mark {
            border-color: #FADCFA;
        }
    }

    .slider__scale-mark {
        border: 1px solid;
        height: 100%;
    }
`;
